module.exports = __webpack_public_path__ + "img/tube.e6236325.png";